import { render, staticRenderFns } from "./ExcecoesSistema.vue?vue&type=template&id=0c4a31f8&scoped=true&"
import script from "./ExcecoesSistema.vue?vue&type=script&lang=js&"
export * from "./ExcecoesSistema.vue?vue&type=script&lang=js&"
import style0 from "./ExcecoesSistema.vue?vue&type=style&index=0&id=0c4a31f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a31f8",
  null
  
)

export default component.exports